/* REFLOW — panier (tiroir et page) sur l'API Ajax de Shopify.
   - Les requêtes partent l'une après l'autre (file d'attente) : le serveur les applique dans l'ordre.
   - Seule la réponse de la dernière demande est affichée ; les réponses dépassées sont ignorées.
   - Chaque résultat est annoncé dans une zone role="status". */
(function () {
  if (customElements.get('rf-cart')) return;
  var routes = (window.Theme && window.Theme.routes) || {};
  var URL_CHANGE = '/cart/change.js';
  var URL_UPDATE = routes.cart_update_url ? routes.cart_update_url + '.js' : '/cart/update.js';
  var URL_ADD = '/cart/add.js';
  var T = window.RF_STRINGS || {};
  function t(key, vars) {
    var s = T[key] || key;
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('[' + k + ']').join(vars[k]); });
    return s;
  }

  var queue = Promise.resolve();
  var seq = 0;

  class RfCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.isDrawer = this.dataset.mode === 'drawer';
      this.dialog = this.querySelector('dialog');
      this.timers = new Map();
      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onThemeCart = this.onThemeCart.bind(this);
      this.onExternal = this.onExternal.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('submit', this.onSubmit);
      this.addEventListener('keydown', this.onKey);
      document.addEventListener('cart:updated', this.onThemeCart);
      document.addEventListener('rf:cart-changed', this.onExternal);
      if (this.isDrawer) {
        this.onOpenClick = this.onOpenClick.bind(this);
        document.addEventListener('click', this.onOpenClick);
      }
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('submit', this.onSubmit);
      this.removeEventListener('keydown', this.onKey);
      document.removeEventListener('cart:updated', this.onThemeCart);
      document.removeEventListener('rf:cart-changed', this.onExternal);
      if (this.onOpenClick) document.removeEventListener('click', this.onOpenClick);
      this.timers.forEach(function (id) { clearTimeout(id); });
    }

    /* ---------- Ouverture ---------- */
    onOpenClick(e) {
      var link = e.target.closest('[data-rf-cart-open]');
      if (!link || !this.dialog) return;
      e.preventDefault();
      this.open(link);
    }
    open(trigger) {
      if (window.RFUI) window.RFUI.openDrawer(this.dialog, trigger);
      else if (this.dialog.showModal) this.dialog.showModal();
    }

    /* Ajout depuis une fiche produit (événement du thème) : on rafraîchit puis on ouvre. */
    onThemeCart(e) {
      var d = (e.detail && e.detail.data) || {};
      if (d.source === 'rf-cart') return;
      var self = this;
      this.refresh().then(function (ok) {
        if (!ok) return;
        self.announce(t('added'));
        if (self.isDrawer && self.dataset.openOnAdd !== 'false' && d.source === 'product-form') {
          self.showNotice(t('added'));
          self.open();
        }
      });
    }
    onExternal(e) { if (e.detail && e.detail.from !== this) this.refresh(); }

    /* ---------- Interactions ---------- */
    onClick(e) {
      var step = e.target.closest('[data-rf-qty]');
      if (step) {
        var line = step.closest('[data-rf-line]');
        var input = line.querySelector('[data-rf-qty-input]');
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-rf-qty'), 10));
        input.value = next;
        this.schedule(line, next, 350);
        return;
      }
      var remove = e.target.closest('[data-rf-remove]');
      if (remove) {
        e.preventDefault();
        var l = remove.closest('[data-rf-line]');
        l.querySelector('[data-rf-qty-input]').value = 0;
        this.schedule(l, 0, 0);
        return;
      }
      if (e.target.closest('[data-rf-code-apply]')) { this.applyCode(); return; }
      var rm = e.target.closest('[data-rf-code-remove]');
      if (rm) { this.removeCode(rm.getAttribute('data-rf-code-remove')); }
    }
    onChange(e) {
      var input = e.target.closest('[data-rf-qty-input]');
      if (!input) return;
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 0) { v = parseInt(input.closest('[data-rf-line]').dataset.qty, 10) || 0; input.value = v; return; }
      this.schedule(input.closest('[data-rf-line]'), v, 0);
    }
    onKey(e) {
      if (e.key === 'Enter' && e.target.matches('[data-rf-code-input]')) { e.preventDefault(); this.applyCode(); }
      if (e.key === 'Enter' && e.target.matches('[data-rf-qty-input]')) { e.preventDefault(); e.target.blur(); }
    }
    onSubmit(e) {
      var form = e.target;
      if (form.matches('.rf-reco__form')) { e.preventDefault(); this.addReco(form); return; }
      /* Le bouton de paiement garde le parcours natif ; on bloque seulement pendant une mise à jour. */
      if (this.querySelector('[data-rf-cart-body]').getAttribute('aria-busy') === 'true') {
        e.preventDefault();
        this.announce(t('wait'));
      }
    }

    schedule(line, qty, delay) {
      var key = line.dataset.key;
      clearTimeout(this.timers.get(key));
      var self = this;
      line.classList.add('is-pending');
      this.timers.set(key, setTimeout(function () {
        self.timers.delete(key);
        self.request(URL_CHANGE, { id: key, quantity: qty }, { line: line, qty: qty });
      }, delay));
    }

    /* ---------- Requêtes ---------- */
    request(url, payload, ctx) {
      var self = this;
      var my = ++seq;
      var body = this.querySelector('[data-rf-cart-body]');
      body.setAttribute('aria-busy', 'true');
      payload.sections = this.sectionId;
      payload.sections_url = window.location.pathname;
      queue = queue.then(function () {
        return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; }); })
          .then(function (res) {
            if (my !== seq) return; /* une demande plus récente a suivi : on n'affiche pas celle-ci */
            if (!res.ok) {
              var msg = (res.json && (res.json.description || res.json.message)) || t('error');
              self.refresh().then(function () {
                var line = ctx && ctx.line && self.querySelector('[data-rf-line][data-key="' + ctx.line.dataset.key + '"]');
                var err = line && line.querySelector('[data-rf-line-error]');
                if (err) { err.textContent = msg; err.hidden = false; }
                self.announce(msg);
              });
              return;
            }
            self.render(res.json.sections && res.json.sections[self.sectionId], res.json);
            if (ctx && typeof ctx.qty === 'number') self.announce(ctx.qty === 0 ? t('removed') : t('updated', { qty: ctx.qty }));
            self.broadcast(res.json.item_count);
            return res.json;
          })
          .catch(function () {
            if (my !== seq) return;
            body.setAttribute('aria-busy', 'false');
            self.querySelectorAll('.is-pending').forEach(function (el) { el.classList.remove('is-pending'); });
            self.announce(t('network'));
            var err = ctx && ctx.line && ctx.line.querySelector('[data-rf-line-error]');
            if (err) { err.textContent = t('network'); err.hidden = false; }
          });
      });
      return queue;
    }

    refresh() {
      var self = this;
      var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + '?sections=' + encodeURIComponent(this.sectionId);
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { self.render(j[self.sectionId]); return true; })
        .catch(function () { self.announce(t('network')); return false; });
    }

    render(html, cartJson) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-rf-cart-body]');
      var current = this.querySelector('[data-rf-cart-body]');
      if (!fresh || !current) return;
      var focusedKey = document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-rf-line]');
      var focusSel = null;
      if (focusedKey && this.contains(focusedKey)) {
        var k = focusedKey.dataset.key;
        var a = document.activeElement;
        focusSel = a.matches('[data-rf-qty="1"]') ? '[data-rf-qty="1"]' : a.matches('[data-rf-qty="-1"]') ? '[data-rf-qty="-1"]' : a.matches('[data-rf-qty-input]') ? '[data-rf-qty-input]' : null;
        focusSel = focusSel ? '[data-rf-line][data-key="' + k + '"] ' + focusSel : null;
      }
      current.replaceWith(fresh);
      fresh.setAttribute('aria-busy', 'false');
      var count = parseInt(fresh.getAttribute('data-count'), 10);
      if (!isNaN(count)) this.setCount(count);
      if (focusSel) { var el = this.querySelector(focusSel); if (el) el.focus(); }
      else if (focusedKey && this.dialog) { var title = this.querySelector('[data-rf-autofocus]'); if (title) title.focus(); }
    }

    setCount(n) {
      document.querySelectorAll('[data-rf-cart-count]').forEach(function (el) {
        el.setAttribute('data-count', n);
        var sr = el.querySelector('.rf-sr');
        if (el.classList.contains('rf-cart__count')) el.textContent = '(' + n + ')';
        else { el.textContent = n; if (sr) el.prepend(sr); }
      });
    }
    broadcast() { document.dispatchEvent(new CustomEvent('rf:cart-changed', { detail: { from: this } })); }
    announce(msg) {
      var s = this.querySelector('[data-rf-cart-status]');
      if (!s) return;
      s.textContent = '';
      setTimeout(function () { s.textContent = msg; }, 60);
    }
    showNotice(msg) {
      var n = this.querySelector('[data-rf-cart-notice]');
      if (!n) return;
      n.querySelector('[data-rf-cart-notice-text]').textContent = msg;
      n.hidden = false;
      clearTimeout(this.noticeTimer);
      this.noticeTimer = setTimeout(function () { n.hidden = true; }, 4000);
    }

    /* ---------- Codes de réduction ---------- */
    currentCodes() {
      return Array.prototype.map.call(this.querySelectorAll('[data-rf-code-remove]'), function (b) { return b.getAttribute('data-rf-code-remove'); });
    }
    applyCode() {
      var input = this.querySelector('[data-rf-code-input]');
      var msg = this.querySelector('[data-rf-code-msg]');
      var code = (input && input.value || '').trim();
      if (!code) { if (msg) msg.textContent = t('code_empty'); return; }
      var codes = this.currentCodes();
      if (codes.indexOf(code) === -1) codes.push(code);
      var self = this;
      this.request(URL_UPDATE, { discount: codes.join(',') }, null).then(function (cartJson) {
        if (!cartJson) return;
        var m = self.querySelector('[data-rf-code-msg]');
        var found = (cartJson.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === code.toUpperCase(); })[0];
        var text = found && found.applicable ? t('code_ok') : t('code_invalid');
        if (m) m.textContent = text;
        self.announce(text);
      });
    }
    removeCode(code) {
      var codes = this.currentCodes().filter(function (c) { return c !== code; });
      this.request(URL_UPDATE, { discount: codes.join(',') }, null);
    }

    /* ---------- Suggestion ---------- */
    addReco(form) {
      var id = form.querySelector('input[name="id"]').value;
      var btn = form.querySelector('button');
      btn.disabled = true;
      var self = this;
      this.request(URL_ADD, { items: [{ id: parseInt(id, 10), quantity: 1 }] }, null).then(function () {
        self.refresh().then(function () { self.announce(t('added')); });
      });
    }
  }
  customElements.define('rf-cart', RfCart);
})();
